import { render, staticRenderFns } from "./MapButton.vue?vue&type=template&id=2ffda38e&"
import script from "./MapButton.vue?vue&type=script&lang=js&"
export * from "./MapButton.vue?vue&type=script&lang=js&"
import style0 from "./MapButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports